"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportedLanguage = void 0;
exports.SupportedLanguage = {
    ENGLISH: 'ENGLISH',
    SPANISH: 'SPANISH',
    MANDARIN: 'MANDARIN'
};
//# sourceMappingURL=supported-language.js.map